<template>
  <div class="d-flex" :class="row ? 'align-baseline' : 'flex-column'" style="width: 100%">
    <div>
      <v-tooltip v-if="helpTooltip" bottom>
        <template #activator="{ on, attrs }">
          <v-btn x-small icon v-bind="attrs" v-on="on">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ helpTooltip }}</span>
      </v-tooltip>

      <slot name="label">
        <p-text variant="bodyMd" :class="row && 'mr-4'">{{ label }}</p-text>
      </slot>
    </div>
    <slot name="sublabel">
      <a v-if="link" target="_blank" :href="link">{{ sublabel ? sublabel : link }}</a>
      <div v-else-if="sublabel">{{ sublabel }}</div>
    </slot>
    <div class="d-flex" :class="{ 'mt-3': !closeLabel, 'flex-grow-1': row }">
      <slot>
        <validation-provider v-slot="{ errors }" :rules="rules" slim :immediate="immediate">
          <v-textarea
            v-if="type === 'textarea'"
            v-model="inputVal"
            :class="{ 'mt-4': !closeLabel, 'mt-1': closeLabel }"
            :placeholder="placeholder"
            :disabled="disabled"
            :hide-details="hideDetails"
            outlined
            auto-grow
            :error-messages="errors.concat(customErrors)"
            rows="3"
            :style="{ 'max-width': width }"
            v-bind="$attrs"
            @blur="onBlur"
          />
          <v-text-field
            v-else
            v-model="inputVal"
            :class="{ 'mt-4': !closeLabel, 'mt-1': closeLabel }"
            :placeholder="placeholder"
            :disabled="disabled"
            outlined
            dense
            :prefix="prefix"
            :hide-details="hideDetails"
            :type="type"
            :error-messages="errors.concat(customErrors)"
            :style="{ 'max-width': width }"
            background-color="#fff"
            v-bind="$attrs"
            @blur="onBlur"
            class="rounded-lg"
          />
        </validation-provider>
      </slot>
      <slot name="button" />
    </div>
  </div>
</template>

<script>
import PText from '@/components/polaris/PText';

export default {
  name: 'InputField',
  components: {
    PText,
  },
  props: {
    value: {
      type: null,
      default: '',
    },
    label: { type: String, default: '' },
    sublabel: { type: String, default: '' },
    link: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: '' },
    width: { type: String, default: '' },
    helpTooltip: { type: String, default: '' },
    rules: { type: String, default: '' },
    disabled: { type: Boolean, default: null },
    prefix: { type: String, default: '' },
    customErrors: { type: Array, default: () => [] },
    closeLabel: { type: Boolean, default: false },
    row: { type: Boolean, default: false },
    immediate: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    onBlur() {
      this.$emit('blur');
    },
  },
};
</script>

<style lang="scss" scoped></style>
